import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

// Styles
import '../../vendor/bootstrap-select/dist/css/bootstrap-select.min.css';
import '../../css/style.css';

// Logo URL from Cloudinary
const logo = "https://res.cloudinary.com/dihtuaq6d/image/upload/v1760187144/xrk9fhrhbahbkvjzy1db.jpg";

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const onSubmit = async (e) => {
    e.preventDefault();
    
    if (!email) {
      setError('Veuillez entrer votre adresse email');
      return;
    }

    setLoading(true);
    setError('');
    setSuccess(false);

    try {
      const response = await axios.post('https://update.senoffre.com/api/auth/password/email', {
        email: email
      }, {
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-AppApiToken': 'senoffre_api_token_2024_secure_key_xyz123'
        }
      });

      if (response.data?.success) {
        setSuccess(true);
      } else {
        setError(response.data?.message || 'Une erreur est survenue');
      }
    } catch (err) {
      console.error('Forgot password error:', err);
      const message = err?.response?.data?.message || 'Erreur lors de l\'envoi du lien de réinitialisation';
      setError(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
      padding: '20px'
    }}>
      <div style={{ 
        background: '#fff', 
        borderRadius: '12px', 
        boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
        padding: '40px',
        width: '100%',
        maxWidth: '450px'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <Link to="/login">
            <img src={logo} alt="SenOffre" style={{ maxWidth: '120px', borderRadius: '8px' }} />
          </Link>
        </div>
        
        <h4 style={{ textAlign: 'center', marginBottom: '10px', color: '#1e293b', fontWeight: '600' }}>
          Mot de passe oublié
        </h4>
        <p style={{ textAlign: 'center', color: '#64748b', marginBottom: '30px', fontSize: '14px' }}>
          Entrez votre adresse email pour recevoir un lien de réinitialisation
        </p>

        {success ? (
          <div style={{ textAlign: 'center' }}>
            <div style={{ 
              background: '#dcfce7', 
              color: '#166534', 
              padding: '16px', 
              borderRadius: '8px',
              marginBottom: '20px'
            }}>
              <i className="fa fa-check-circle" style={{ marginRight: '8px' }}></i>
              Un lien de réinitialisation a été envoyé à votre adresse email.
            </div>
            <p style={{ color: '#64748b', marginBottom: '20px' }}>
              Vérifiez votre boîte de réception et cliquez sur le lien pour réinitialiser votre mot de passe.
            </p>
            <Link 
              to="/login" 
              style={{
                display: 'inline-block',
                padding: '12px 24px',
                background: 'linear-gradient(135deg, #145650 0%, #0d3d39 100%)',
                color: '#fff',
                borderRadius: '8px',
                textDecoration: 'none',
                fontWeight: '500'
              }}
            >
              Retour à la connexion
            </Link>
          </div>
        ) : (
          <form onSubmit={onSubmit}>
            {error && (
              <div style={{ 
                background: '#fef2f2', 
                color: '#dc2626', 
                padding: '12px 16px', 
                borderRadius: '8px',
                marginBottom: '20px',
                fontSize: '14px'
              }}>
                <i className="fa fa-exclamation-triangle" style={{ marginRight: '8px' }}></i>
                {error}
              </div>
            )}

            <div style={{ marginBottom: '20px' }}>
              <label style={{ display: 'block', marginBottom: '8px', fontWeight: '500', color: '#374151' }}>
                Email
              </label>
              <input
                type="email"
                placeholder="Entrez votre adresse email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                style={{
                  width: '100%',
                  padding: '12px 16px',
                  border: '1px solid #d1d5db',
                  borderRadius: '8px',
                  fontSize: '14px',
                  outline: 'none',
                  boxSizing: 'border-box'
                }}
              />
            </div>

            <button
              type="submit"
              disabled={loading}
              style={{ 
                width: '100%',
                padding: '14px',
                background: loading ? '#9ca3af' : 'linear-gradient(135deg, #145650 0%, #0d3d39 100%)',
                color: '#fff',
                border: 'none',
                borderRadius: '8px',
                fontSize: '16px',
                fontWeight: '500',
                cursor: loading ? 'not-allowed' : 'pointer',
                marginBottom: '20px'
              }}
            >
              {loading ? 'Envoi en cours...' : 'Envoyer le lien de réinitialisation'}
            </button>

            <div style={{ textAlign: 'center' }}>
              <Link 
                to="/login" 
                style={{ color: '#145650', textDecoration: 'none', fontSize: '14px' }}
              >
                ← Retour à la connexion
              </Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
